import { useParams } from "react-router-dom"
import { CloudUpload } from "@mui/icons-material"
import useCancelUploadPrompt from "hooks/upload-cancel-prompt"
import HomeHeader from "modules/home-header"
import { Creators } from "./model"

interface Props {
  account: string
}

export default function ExperimentPositionsHeader({ account }: Props) {
  // The upload always belongs to the topic in the path, so cancelling needs no loaded experiment.
  const { topicId } = useParams()
  const promptCancel = useCancelUploadPrompt(`/${account}/t/${topicId}/experiments/summary`, Creators.resetUpload)

  return <HomeHeader account={account} Icon={CloudUpload} title="Upload Alternative Experiment" onLogoClick={promptCancel} />
}
